export function todayLocal(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function isWeekend(date: string): boolean {
  const [y, m, d] = date.split('-').map(Number);
  const dow = new Date(y, m - 1, d).getDay();
  return dow === 0 || dow === 6;
}

function parseDate(s: string): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

function formatDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function previousEligibleDays(date: string, n: number, weekdaysOnly: boolean): string[] {
  const out: string[] = [];
  const cursor = parseDate(date);
  while (out.length < n) {
    cursor.setDate(cursor.getDate() - 1);
    const dow = cursor.getDay();
    const isWeekendDay = dow === 0 || dow === 6;
    if (weekdaysOnly && isWeekendDay) continue;
    out.push(formatDate(cursor));
  }
  return out;
}
